function Footer() {
  return (
    <footer className="max-w-6xl mx-auto mt-[150px] flex flex-col lg:flex-row px-6 lg:px-0 justify-between mb-[95px]">
      <div className="flex flex-col gap-4 w-full lg:w-[448px]">
        <img src="./logo.svg" alt="" className="w-[212px] h-[48px]" />
        <h1 className="text-base font-semibold text-abu2 leading-[22px] tracking-[-0.7px]">
          Aplikasi Quran Online Terlengkap dengan kemudahan membaca,
          mendengarkan, dan memahami Al-Quran di mana saja dan kapan saja.
        </h1>
        <p className="text-base font-semibold text-abu2 leading-[22px] tracking-[-0.7px]">
          © 2024 SobatQuran. Semua Hak Dilindungi
        </p>
      </div>

      <div className="flex flex-wrap justify-between mt-10 lg:mt-0 lg:justify-center gap-[60px]">
        <div className="flex flex-col gap-6">
          <h1 className="text-[20px] font-semibold text-hijau">Overview</h1>
          <ul className="flex flex-col gap-4">
            <li className="text-base text-abu2 font-medium tracking-[-0.7px]">
              Beranda
            </li>
            <li className="text-base text-abu2 font-medium tracking-[-0.7px]">
              Baca Quran
            </li>
            <li className="text-base text-abu2 font-medium tracking-[-0.7px]">
              Jadwal Sholat
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-6">
          <h1 className="text-[20px] font-semibold text-hijau">Another</h1>
          <ul className="flex flex-col gap-4">
            <li className="text-base text-abu2 font-medium tracking-[-0.7px]">
              Artikel
            </li>
            <li className="text-base text-abu2 font-medium tracking-[-0.7px]">
              Kontak
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-6">
          <h1 className="text-[20px] font-semibold text-hijau">Explore Us</h1>
          <ul className="flex flex-col gap-4">
            <li className="text-base text-abu2 font-medium tracking-[-0.7px]">
              Privacy
            </li>
            <li className="text-base text-abu2 font-medium tracking-[-0.7px]">
              Terms & Conditions
            </li>
          </ul>
        </div>
        <div className="flex flex-col gap-6">
          <h1 className="text-[20px] font-semibold text-hijau">Social Media</h1>
          <ul className="flex flex-col gap-4">
            <div className="flex gap-2">
              <img src="./img/ig.svg" alt="" />
              <li className="text-base text-abu2 font-medium tracking-[-0.7px]">
                Instagram
              </li>
            </div>
            <div className="flex gap-2">
              <img src="./img/wa.svg" alt="" />
              <li className="text-base text-abu2 font-medium tracking-[-0.7px]">
                Whatsapp
              </li>
            </div>
            <div className="flex gap-2">
              <img src="./img/Yt.svg" alt="" />
              <li className="text-base text-abu2 font-medium tracking-[-0.7px]">
                Youtube
              </li>
            </div>
            <div className="flex gap-2">
              <img src="./img/fb.svg" alt="" />
              <li className="text-base text-abu2 font-medium tracking-[-0.7px]">
                Facebook
              </li>
            </div>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
